"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAllocationsFilterItems = exports.useAllocationsFilter = void 0;
var _react = require("react");
var _api = require("@focaltec-suite/api");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
var useAllocationsFilterItems = exports.useAllocationsFilterItems = function useAllocationsFilterItems(allocationConfigurations) {
  var allocationConfigurationOptions = (0, _react.useMemo)(function () {
    return allocationConfigurations.map(function (company) {
      return {
        value: company.id,
        label: company.name
      };
    });
  }, [allocationConfigurations]);
  var statusOptions = (0, _react.useMemo)(function () {
    return _api.DOCUMENT_STATUSES.filter(function (el) {
      return el !== 'DELETED';
    }).map(function (el) {
      return {
        value: el,
        label: (0, _core.translate)("status.male.".concat(el))
      };
    });
  }, []);
  var filters = (0, _react.useMemo)(function () {
    return [{
      name: 'search',
      label: (0, _core.translate)('filters.search'),
      type: 'text'
    }, {
      name: 'allocationConfigurationId',
      label: (0, _core.translate)('allocation_configurations.single'),
      options: allocationConfigurationOptions
    }, {
      name: 'status',
      label: (0, _core.translate)('status.title'),
      options: statusOptions
    }];
  }, [allocationConfigurationOptions, statusOptions]);
  return filters;
};
var useAllocationsFilter = exports.useAllocationsFilter = function useAllocationsFilter(allocationConfigurations, query) {
  var items = useAllocationsFilterItems(allocationConfigurations);
  var params = (0, _commons.useFilterParams)(items, query);
  return params;
};